import React, { Component } from 'react';

import "./Calendar-Board.scss"

class CalendarBoard extends Component {
    constructor(props) {
        super();
        this.state = {
        }
    }
    render() {
        const monthBoard = {
            backgroundImage: "url(./static/images/calendar/" + (window.screen.width <= 768 ? "mob" : "desk") + "/" + this.props.currBoard + ".png)"
        }
        return (
            <div className="calendar_board" style={monthBoard}></div>
        );
    }
}

export default CalendarBoard;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Calendar-Board/Calendar-Board.js